import { createBrowserRouter, Navigate } from 'react-router-dom'
import { GuestRoute, MainLayoutRoute, ProtectedRoute } from './components'
import { LoginPage } from '@/features/auth'
import { DashboardPage } from '@/features/referrals'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <GuestRoute>
        <LoginPage />
      </GuestRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayoutRoute>
          <DashboardPage />
        </MainLayoutRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
])
